export const DOMAIN_EMISSION_FACTORS = "EMISSION_FACTORS";
